import { render } from "./eatXfbPiceUpdate.vue?vue&type=template&id=5bc6fc05"
import script from "./eatXfbPiceUpdate.vue?vue&type=script&lang=js"
export * from "./eatXfbPiceUpdate.vue?vue&type=script&lang=js"

import "./eatXfbPiceUpdate.vue?vue&type=style&index=0&id=5bc6fc05&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__